import React, { Component } from 'react';
import { Translate } from '../contexts/Language';
import { ErrorMessage } from './Validator';
import { Service } from '../services';
import { Config } from '../config';

export class LimitEdit extends Component {

    constructor(props) {
        super(props)

        this.state = {
            formData: {
                transferOption: this.props.Data.transferOption,
                maxLimit: this.props.Data.maxLimit,
                minLimit: this.props.Data.minLimit
            },
            validation: {
                error: false,
                message: ""
            }
        }
    }
    onFormChange(e, key) {

        let formData = this.state.formData;

        formData[key] = e.target.value;

        this.setState({
            formData
        });

    }
    onSave() {

        Config.utilities.loadingFetch();

        Service.TransferOptions.DailyLimitSave(this.state.formData).then(response => {

            if (response.error) {

                this.setState({
                    validation: {
                        error: response.error,
                        message: response.message
                    }
                });
            }

            Config.utilities.loadingFetch();
        });
    }
    render() {
        return (
            <div className="col-md-4 mb-4">
                <ErrorMessage Validation={this.state.validation} />
                <div className="img-thumbnail p-3">
                    <span className="d-block mb-3 limit-logo"><img src={"/assets/psp-logo/" + (this.props.Data.transferOptionLogo || "defaultlogo.svg")} alt="" width="30" className="mb-1" />&nbsp; {this.props.Data.transferOptionTitle}  {this.props.Data.acceptedCurrencies.map(item => (<span key={item} className="badge badge-light m-1">{Translate(item)}</span>))}</span>
                    <div className="row">
                        <div className="form-group input-group-sm col-lg-5 pl-4">
                            <label htmlFor="name">Minimum</label>
                            <input type="number" id="minimum" name="minimum" className="form-control input-sm" value={this.state.formData.minLimit} onChange={(e) => this.onFormChange(e, "minLimit")} />
                        </div>
                        <div className="form-group input-group-sm col-lg-5 pr-4">
                            <label htmlFor="name">Maximum</label>
                            <input type="number" id="maximum" name="maximum" className="form-control input-sm" value={this.state.formData.maxLimit} onChange={(e) => this.onFormChange(e, "maxLimit")} />
                        </div>
                        <div className="col-lg-2">
                            <button type="button" className="btn btn-primary float-right mr-2 mt-4" onClick={(e) => this.onSave()}>Save</button>
                        </div>
                    </div>
                </div>
            </div>)
    }

}
